import styled from "styled-components";
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const CardContainerWrapper = styled(CardContainer)(({ theme }) => {
    return {
        margin: `0 ${theme.spacing.medium}`,
    };
});

export const BorderDiv = styled.div(({ theme }) => {
    return {
        borderBottom: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
        "&:last-child": {
            borderBottom: 0,
        },
    };
});

export const TextWrapper = styled(Text)(({ theme }) => {
    return {
        paddingLeft: theme.spacing.medium,
        marginTop: theme.spacing.medium,
        textTransform: "uppercase",
    };
});
